import React, { useState } from "react";
import { Box } from "@mui/material";
import RoiHeroSection from "./sections/RoiHeroSection";
import RoiCalculatorSection from "./sections/RoiCalculatorSection";
import MeetingModal from "../../MeetingModal";

const RoiCalculatorPage = () => {
  const [showMeeting, setShowMeeting] = useState(false);
  const handleBookDemo = () => setShowMeeting(true);

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        backgroundColor: "#FFFFFF",
        overflowX: "hidden",
      }}
    >
      <RoiHeroSection />
      <RoiCalculatorSection onBookDemo={handleBookDemo} />

      <MeetingModal showMeeting={showMeeting} setShowMeeting={setShowMeeting} />
    </Box>
  );
};

export default RoiCalculatorPage;
